import { render, staticRenderFns } from "./MemberActionLayout.vue?vue&type=template&id=6829796a&scoped=true&"
import script from "./MemberActionLayout.vue?vue&type=script&lang=js&"
export * from "./MemberActionLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6829796a",
  null
  
)

export default component.exports